<template>
  <div class="addcourse courseware">
    <!--面包屑-->
    <div class="crumbs">
      <!-- <span><router-link :to="{name:'Transition'}">首页</router-link></span> > -->
       <span>首页</span>>
      <span>教学课件</span>
    </div>
    <!--表格-->
    <div class="addCourse">
      <div class="addBtn" @click="_addBtn">添加课件</div>
      <div class="rightSearch">
        <input v-model="keyword" class="radius_input" placeholder="请输入关键字" type="text" @keyup.enter="_search('1')">
        <i @click="_search('1')" class="pointer el-icon-search"></i>
      </div>
    </div>
    <p-table :head="head" :data="dataList" @_operation="_operation_" :autoheight="autoheight" :dynamicOperationName="'courseWare'" v-loading="loading"></p-table>
    <div class="pageCont">
      <page :total="page.total" :allPage="page.allPage" :currentPage="page.currentPage" @current-page="__currentPage"
            @page-size="__pageSize"></page>
    </div>
    <right-pops v-if="popShow">
      <router-view/>
    </right-pops>
  </div>
</template>

<script type="text/ecmascript-6">
  import pTable from '@/components/common/tables/publicTable'
  import page from '@/components/common/page/page'
  import router from '../../../../router'
  import rightPops from '@/components/common/right/rightPops'
  import * as _ from '@/common/js/config'
  import http from '@/api/http'
  import {message} from '@/common/js/messages'
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  import {changehosArea,changeAge,changeGender,changeSex} from '@/common/js/change'
  export default {
    components: {
      pTable,
      page,
      rightPops
    },
    watch: {
      popShow(c, o) {
        if (c === false) {
          this._search(this.page.currentPage)
        }
      }
    },
    data() {
      return {
        autoheight:this.getH(),
        popShow: false,
        loading: false,
        keyword: '',
        tableheight:260,
        page: {
          currentPage: 1,
          pageSize: 30,
          total: 0,
          allPage: 0
        },
        dataList: [],
        head: [
          {
            props: 'subject',
            label: '课件名称',
            width: '16%'
          },
          {
            props: 'creatorName',
            label: '创建人',
            width: '8%'
          },
          {
            props: 'createDateStr',
            label: '创建时间',
            width: '17%'
          },
          {
            props: 'hosName',
            label: '所属机构',
            width: '17%'
          },
          {
            props: 'keywords',
            label: '关键词',
            width: '10%'
          },
          {
            props: 'openFlag',
            label: '是否公开',
            width: '10%'
          },
          {
            props: 'courseType',
            label: '课件分类',
            width: '10%'
          }
        ],
      }
    },
    methods: {
      getH(){
        this.autoheight = document.body.clientHeight - 50 - 40 - 44 - 40 - 15  //header + crumb + search + pages + marinbottom
      },
      __currentPage(payload) {
        this.page.currentPage = payload
        this._search(this.page.currentPage)
      },
      __pageSize(payload) {
        this.page.pageSize = payload
        this._search(this.page.currentPage)
      },
      _search(cPage) {
        this.loading = true
        let page = 0
        if (cPage === '1') {
          page = 1
          this.page.currentPage = 1
        } else {
          page = cPage
          this.page.currentPage = cPage
        }
        let params = {
          keyword: this.keyword,
          pageSize: this.page.pageSize,
          currentPage: page
        }
        http.post('/materia/queryMeteriaList.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.loading = false
            this.dataList = res.data.model
            for (let item of this.dataList) {
              if (item.openFlag === '1') {
                item.openFlag = '公开'
              } else {
                item.openFlag = '私人'
              }
            }
            this.page.total = res.data.totalItem
          } else {
          //  message(res.data.msg, false)
          }
        }).catch(err => {
         // errMsg(err)
        })
      },
      _operation_(payload) {
       if (payload.operation === 'icon-chakan') {
           let params = {
             id: payload.id
           }
           http.post('/materia/getMateriaDetail.json', params).then(res => {
             if (res.data.code === _.ERR_OK) {
               this.popShow = true
               for (let item of res.data.model.studyList) {
                 item.patientSex = changeGender(item.patientSex);
               }
               this.$router.push({name: 'QuerycourseWareInfo'})
               saveLocalStorage(res.data.model, 'detail')
             } else {
             //  message(res.data.msg, false)
             }
           }).catch(err => {
            // errMsg(err)
           })
        } else if (payload.operation === 'icon-bianji') {
           let params = {
             id: payload.id
           }
           http.post('/materia/getMateriaDetail.json', params).then(res => {
             if (res.data.code === _.ERR_OK) {
               this.$router.push({name: 'ModifyCourseWare'})
               saveLocalStorage(res.data.model, 'bianjiData')
               saveLocalStorage(true, 'isModify')
             } else {
             //  message(res.data.msg, false)
             }
           })
       } else if (payload.operation === 'icon-shanchu') {
         this.$confirm('是否确定要删除?', '提示', {
           confirmButtonText: '确定',
           cancelButtonText: '取消',
         }).then(() => {
           let params = {
             id: payload.id
           }
           http.post('/materia/delMateria.json', params).then(res => {
             if (res.data.code === _.ERR_OK) {
               this._search()
             } else {
           //    message(res.data.msg, false)
             }
           }).catch(err => {
             errMsg(err)
           })
         })
       }
      },
      _addBtn() {
        this.popShow = true
        this.$router.push({name: 'AddCourseWare'})
        saveLocalStorage(false, 'isModify')
      },
      _routerEach() {
        router.beforeEach((to, from, next) => {
          if (from.name === 'CourseWare') {
            this.popShow = true
          } else {
            this.popShow = false
          }
          next()
        })
      }
    },
    mounted() {
      setTimeout(() => {
        this._routerEach()
        if (this.$route.path === '/Homepage/CourseWare') {
          this.popShow = false
        } else {
          this.popShow = true
        }
      }, 20)

      window.addEventListener('resize', () => {
        setTimeout(() => {
          this.getH()
        }, 50)
      })
    },
    created() {
      this.getH()
      this._search('1')
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .courseware
    position: relative
    width: 98%
    margin: auto
  .addCourse
    height: 46px
    background: $color-background-d
  .addBtn
    width: 80px
    height: 27px
    position: relative
    top: 9.5px
    left: 20px
    line-height: 27px
    text-align: center
    cursor: pointer
    background: $color-btn
    color: $color-index-text
    border-radius: 3px
  .rightSearch
    width: 40%
    float: right
    position: relative
  .radius_input
    min-width: 200px
    width: 70%
    background: #f2f2f2
    height: 24px
    border-radius: 20px
    position: absolute
    right: 20px
    top: -14px
    padding: 0 20px

  .pointer
    position: absolute
    right: 30px
    top: -9px
</style>



// WEBPACK FOOTER //
// courseWare.vue?4e997da9